export default function ({ store, route, redirect }) {
  const { prf, trf, source, ...otherQueryParams } = route.query
  const hasReferralUrl = prf || trf

  if (hasReferralUrl) {
    const timestamp = Date.now()
    if (trf) {
      store.commit('setReferral', { trf, source, timestamp })
    }

    if (prf) {
      store.commit('setReferral', { prf, source, timestamp })
    }

    return redirect({ path: route.path, query: otherQueryParams })
  }
}
